import React from "react"
import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  InputGroup,
  Flex,
} from "@chakra-ui/react"
import { COLORS } from "../constants/constants"

const CustomNumberInput = ({ value, onChange = () => {}, min, max }) => {
  const handleBlurEvent = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <Flex>
      <InputGroup width={"100px"}>
        <NumberInput
          min={min}
          max={max}
          value={value}
          onChange={(valueString) => onChange(Number(valueString))}
        >
          <NumberInputField
            padding="8px 8px 8px 12px"
            border={"1px solid #EEEFF1"}
            borderRadius={"12px"}
            boxShadow={"none!important"}
            _focus={{
              borderColor: COLORS.black,
            }}
            onBlur={handleBlurEvent}
            readOnly
          />
          <NumberInputStepper
            width={"12px"}
            margin={0}
            gap={1}
            justifyContent={"center"}
            mr={3}
          >
            <NumberIncrementStepper
              border={"none"}
              color={COLORS.secondary}
              flex={"none"}
            />
            <NumberDecrementStepper
              border={"none"}
              color={COLORS.secondary}
              flex={"none"}
            />
          </NumberInputStepper>
        </NumberInput>
      </InputGroup>
    </Flex>
  )
}

export default CustomNumberInput
